const baseGeneralUrl = "General"

const endpoints = {
    getSavedSearchs:`${baseGeneralUrl}/GetSavedSearches`,
    addSavedSearch:`${baseGeneralUrl}/CreateSavedSearch`,
    updateSavedSearch:`${baseGeneralUrl}/UpdateSavedSearch`,
    deleteSavedSearch:`${baseGeneralUrl}/DeleteSavedSearch`,
   
    
   };
   
   export default endpoints;